var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bot-index"}},[_c('bot-fund-types',{attrs:{"pf":_vm.pf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }